<template>
  <v-card variant="outlined" class="pa-3 my-3">
    <div class="text-subtitle-2">
      {{ seat?.seatNumber ? `${seat.seatNumber}` : "" }}
    </div>
    <div
      v-if="seat?.assignedFirstName || seat?.assignedLastName"
      class="text-caption"
    >
      {{ seat.assignedFirstName }} {{ seat.assignedLastName }}
    </div>

    <v-btn
      size="small"
      variant="outlined"
      :href="`/api/TicketPurchaseDto/singleSeatDownload/${purchasePublicId}/${seat?.ticketId}${seatIdParam}?download=true`"
      target="_blank"
      :disabled="disabled"
    >
      <v-icon start>fal fa-download</v-icon> Download
    </v-btn>
  </v-card>
</template>

<script setup lang="ts">
import type { TicketPurchaseSeat } from "@/models.g";

const props = defineProps<{
  seat: TicketPurchaseSeat | null | undefined;
  index: number;
  purchasePublicId: string;
  disabled?: boolean;
}>();

const seatIdParam = computed(() => `/${props.seat?.seatId}`);
</script>
